import { render } from "./eventprice.vue?vue&type=template&id=03fbf848&scoped=true"
import script from "./eventprice.vue?vue&type=script&lang=js"
export * from "./eventprice.vue?vue&type=script&lang=js"

import "./eventprice.vue?vue&type=style&index=0&id=03fbf848&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03fbf848"

export default script